<template>
  <div>
     
    <b-modal 
    id="edit-task-modal"
    v-model="settings" 
    @hidden="resetModal"
    title="Task Settings"
    @ok="handleOk"

    >
        <b-container fluid>
          <Loading v-if="loading"/>
         
            <b-form @submit.stop.prevent ="onSubmit" >
       
              <b-form-group
                id="input-group-1"
                label="Task Name:"
                label-for="input-1"
              
              >
                <b-form-input
                  id="input-1"
                  v-model="form.name"
                  type="text"
                  placeholder="Enter task name"
                  required
                ></b-form-input>
                <div class="text-danger text-center">
                    <span v-if="!$v.form.name.required && $v.form.name.$anyDirty">Task name is required</span>
                </div>
              </b-form-group>
              
              <b-form-group
                id="input-group-1"
                label="Recomended Time:"
                label-for="input-1"
                
              >
               <div class="row ml-0 mb-3" v-for="(item, index) in form.time"
                :key="index">
                <badge class="col-3 mt-auto mb-auto mr-3" pill type="primary">{{ dayOfWeekAsInteger(index) }}</badge>
             
                <b-form-input
                  id="input-1"
                  v-model="form.time[index].Time"
                  type="time"
                  required
                  class="col-8"
                ></b-form-input>

               </div>
                <div class="text-danger text-center">
                    <span v-if="!$v.form.time.required && $v.form.time.$anyDirty">Task time is required</span>
                </div>
              </b-form-group>

            </b-form>
        </b-container>
    </b-modal>
  </div>
</template>

<script>
import Loading from '../../Loading'
import { required } from 'vuelidate/lib/validators'

  export default {
    components:{
      Loading
    },
    props: {
      task: {
        type: Object
      }
    },
    data() {
      return {
          form:{
            name:'',
            time:{},
            id:''
          },
          settings:false,
          loading:false,
         
      }
    },
    validations () {
        return {
            form: { 
                name: { required },
                time: { required },
                id: { required }
            }
        
        }
    },
    watch: { 
      	task: function(newTask, oldTask) { 
          this.form.name = newTask.TaskName
          this.form.time = newTask.RecommendedTime
          this.form.id = newTask.TaskID
        }
    },
    
    methods:{
      dayOfWeekAsInteger(day) {
        let days= ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday",]
        return days[day];
      },
      resetModal() {
           this.form.name = ''
           this.form.time = ''
           this.form.id = ''
        
      },
      handleOk(bvModalEvt){

        bvModalEvt.preventDefault()
        this.handleSubmit()

      },
      handleShow(){

          this.settings = !this.settings

      },
      handleSubmit(){
         this.$v.$touch();
         if(this.$v.$error) return

         this.loading = true
         fetch(`${process.env.VUE_APP_APIURL}/attendance/task/${this.form.id}`, 
            {
                method:'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization':this.$store.state.token
                },
                body : JSON.stringify({ "name":this.form.name , "time":this.form.time })
            })
            .then(response => response.json())
            .then(data => {   

                this.$store.dispatch("getTasks") 
                this.$emit('changeMsg', 'Task updated')
               

                setTimeout(() => {   
                  this.loading=false
                  this.$bvModal.hide('edit-task-modal')
                 
                }, 2000);            
            })
            .catch(err => {
                setTimeout(() => {
                    this.loading=false
                    this.$emit('changeError', 'Something went wrong.')
                }, 2000);
            });

           


      },
    
    }
  }
</script>